import { jsx as _jsx } from "react/jsx-runtime";
import './where-i-am.sass';
import { memo } from 'react';
import { IconButton } from '@mui/material';
import { requestPermissionForOrientation } from 'shared/map/lib/compass';
export const WhereIAm = memo(function WhereIAm(props) {
    return (_jsx(IconButton, { disableRipple: true, "aria-controls": "where-i-am", className: "ui-map-where-i-am", onClick: (event) => {
            event.preventDefault();
            requestPermissionForOrientation();
            props.showLocation();
        }, title: "\u0413\u0434\u0435 \u044F?", size: "large" }));
});
